import Button from '@cobliteam/colib-ui/Button';
import { cn as _cnTypography } from '@cobliteam/colib-ui/cn';
import { Dialog, DialogBody, DialogClose, DialogContent, DialogDescription, DialogHeader, DialogTitle } from '@cobliteam/colib-ui/Dialog';
import DialogCloseIcon from '@cobliteam/colib-ui/Icon';
import Typography from '@cobliteam/colib-ui/Typography';
import { useTranslation } from '@cobliteam/i18n';
import i18nConfig from '@cobliteam/i18n/src/config/i18next.config';
import slideCobliConecta from '@cobliteam/ui-business/components/dialogs/DialogRemoteConnection/assets/slide-cobli-conecta-qr-2x.png';
import { NUDGE_SURFACE } from '@cobliteam/ui-business/components/Nudge/nudgeSurface';
import { useState } from 'react';

interface CobliConectaSuggestionSlideProps {
  onAccept: (metadata?: Record<string, unknown>) => void;
  onDismiss: (reason?: string) => void;
}
const CobliConectaSuggestionSlide = ({ onAccept, onDismiss }: CobliConectaSuggestionSlideProps) => {
  const { t } = useTranslation('suggestions');
  const [qrOpen, setQrOpen] = useState(false);
  const handleAccept = () => {
    onAccept({
      via: 'qr-code',
    });
    setQrOpen(true);
  };
  return (
    <>
      <div data-testid='cobli-conecta-suggestion' className='flex w-full flex-col gap-[9px]'>
        <Typography variant='body' className={_cnTypography('gap-1 break-words', 'font-medium', 'text-foreground', NUDGE_SURFACE.title)}>
          {t('cobli_conecta.title')}
        </Typography>

        <Typography variant='body' className={_cnTypography('gap-1 break-words', 'text-foreground', `text-start ${NUDGE_SURFACE.muted}`)}>
          {t('cobli_conecta.description')}
        </Typography>

        <div className='flex items-center justify-between gap-2 pt-1'>
          <Button variant='ghost' size='sm' data-testid='cobli-conecta-suggestion-not-interested' onClick={() => onDismiss('not-interested')}>
            {t('cobli_conecta.not_interested')}
          </Button>
          <Button size='sm' onClick={handleAccept} data-testid='cobli-conecta-suggestion-cta'>
            {t('cobli_conecta.cta')}
          </Button>
        </div>
      </div>

      <Dialog
        open={qrOpen}
        onOpenChange={(isOpen) => {
          if (!isOpen) setQrOpen(false);
        }}
      >
        <DialogContent size='md' showCloseButton={false}>
          <DialogHeader className='flex-row items-center justify-between justify-between'>
            <DialogTitle>{t('cobli_conecta.qr_dialog.title')}</DialogTitle>
            <DialogDescription className='sr-only'>{t('cobli_conecta.qr_dialog.body')}</DialogDescription>
            <DialogClose
              onClick={() => setQrOpen(false)}
              aria-label={i18nConfig.t('common:buttons.close')}
              data-testid={'dialog-close'}
              render={
                <Button variant='ghost' size='icon-sm'>
                  <DialogCloseIcon name='x' size='sm' />
                </Button>
              }
            />
          </DialogHeader>
          <DialogBody className='flex flex-col gap-4'>
            <Typography variant='body' className='gap-1 break-words text-muted-foreground'>
              {t('cobli_conecta.qr_dialog.body')}
            </Typography>
            <div className='w-full overflow-hidden rounded-md'>
              <img src={slideCobliConecta} alt={t('cobli_conecta.qr_dialog.title')} className='w-full' data-testid='cobli-conecta-qr-image' />
            </div>
          </DialogBody>
        </DialogContent>
      </Dialog>
    </>
  );
};
export default CobliConectaSuggestionSlide;
